export const ImagesConfig = ($stateProvider) => {
  'ngInject';
  $stateProvider.state('app.imageCategories', {
    url: '^/image-categories',
    template: '<image-category-list></image-category-list>'
  });
  $stateProvider.state('app.imageCategoryAdd', {
    url: '^/image-category-add',
    template: '<image-category-add></image-category-add>'
  });
  $stateProvider.state('app.imageCategoryEdit', {
    url: '^/image-category-edit/:id',
    template: '<image-category-edit></image-category-edit>'
  });
  $stateProvider.state('app.images', {
    url: '^/images/:parentId',
    template: '<image-list></image-list>'
  });
  $stateProvider.state('app.addImage', {
    url: '^/add-image',
    template: '<image-add></image-add>'
  });
  $stateProvider.state('app.editImage', {
    url: '^/edit-image/:id',
    template: '<image-edit></image-edit>'
  });
};


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/images/components/images.config.js
 **/